
import { Component, Prop, Vue } from 'vue-property-decorator'
import { IContactData } from '@/types/contact-types'
import { UserService, ContactService } from '@/services/index'
import { NIUMEI_HOST } from '@/config/env'
import MemoDialog from '@/views/user/components/memo.vue'

/**
 * 
 * @prop contacts 联系列表
 * 
*/

@Component({
    name: 'ContactTable',
    components: {
        MemoDialog
    }
})
export default class extends Vue {
    @Prop({ type: Array, required: true }) private contacts!: IContactData[]

    private claimStatus = {
        0: '未认领',
        1: '已认领'
    }
    private typeStatus = {
        1: '报料',
        2: '邀请',
        3: '反馈问题'
    }
    private statusOptions = [
        { key: 1, value: '未跟进' }, 
        { key: 2, value: '跟进中' }, 
        { key: 3, value: '跟进完成' }, 
        { key: 4, value: '无需跟进' }
    ]
    private mapVipLevel = {
        0: '普通用户',
        3: 'VIP',
        1: '高级VIP',
        2: '超级VIP'
    }
    private users = []
    private NIUMEI_HOST: string = NIUMEI_HOST
    private curMemo = ''
    private curUser: any = ''

    private get memoDialog() {
        return this.$refs.memoDialogRef as any
    }

    private mounted() {
        this.getUsers()
    }

    private async getUsers() {
        const result = await UserService.getUsers({ page_index: 1, page_size: 100 })
        if (result.status === 200) {
            this.users = result.data.users
        }
    }

    private async updateContact(params: any) {
        const result = await ContactService.updateContact(params)
        if (result.status === 200) {
            this.$message({ type: 'success', message: '设置成功' })
            return { status: true }
        }
        return {
            status: false,
            message: result.message
        }
    }

    private async onStatusSelect(status: any, item: any) {
        const { id: contactId } = item
        const params = { id: contactId, followStatus: status }
        const result = await this.updateContact(params)
        if (result.status) {
            item.status = status
        } else {
            this.$message({
                type: 'error',
                message: result.message || '修改失败',
                showClose: true
            })
        }
    }

    private async onUserSelect(userId: string, item: any) {
        const { id: contactId } = item
        const params = { id: contactId, pdUserId: userId }
        const result = await this.updateContact(params)
        if (result.status) {
            // 没负责人时应该是 null 或者 undefined
            // 没有被 vue 监听到
            this.$set(item.principal, 'id', userId)
        } else {
            this.$message({
                type: 'error',
                message: result.message || '修改失败',
                showClose: true
            })
        }
    }

    private onEditMemo(user: any) {
        this.curMemo = user.memo
        this.curUser = user
        this.memoDialog.show()
    }

    private async onUpdateInfo({ memo }: any) {
        const { status, message } = await this.updateContact({ id: this.curUser.id, memo })
        if (status) {
            this.curUser.memo = memo
        } else {
            this.$message({
                type: 'error',
                message: message || '修改发生错误',
                showClose: true
            })
        }
        this.memoDialog.close()
    }
}
